import { RouterProvider } from 'react-router-dom';
import { AppContainer } from 'shared/app/AppContainer';
import { renderApp } from 'shared/app/AppRenderer';
import { initHeapCarrierGuidSync } from 'shared/helpers/Analytics';
import { router } from './carrier-router';

initHeapCarrierGuidSync();

renderApp(
  <AppContainer>
    <RouterProvider router={router} />
  </AppContainer>,
);
